// 所在页面不主动弹出考勤
// 扫码后页面、考勤失败页
const list = ['/checkIn/studentCheckinIndex', '/checkIn/fail']

export default list;
